export { Flower as default } from './Flower';
